if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.initNav();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`,
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`,
        );
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      initNav() {
        if (this._navInit) return;
        this._navInit = true;

        // dialog 내부 pointerup이 product-modal까지 버블링되면
        // ModalDialog의 핸들러가 모달을 닫아버리므로 차단
        const dialog = this.querySelector('[role="dialog"]');
        if (dialog) dialog.addEventListener('pointerup', (e) => e.stopPropagation());

        const prevBtn = this.querySelector('.product-media-modal__nav--prev');
        const nextBtn = this.querySelector('.product-media-modal__nav--next');
        if (!prevBtn || !nextBtn) return;

        prevBtn.addEventListener('click', () => this.navigate(-1));
        nextBtn.addEventListener('click', () => this.navigate(1));

        document.addEventListener('keydown', (e) => {
          if (!this.open) return;
          if (e.key === 'ArrowLeft') this.navigate(-1);
          if (e.key === 'ArrowRight') this.navigate(1);
        });

        const content = this.querySelector('[role="document"]');
        if (content) {
          let touchStartX = 0;
          let touchStartY = 0;
          let isHorizontalSwipe = false;

          content.addEventListener(
            'touchstart',
            (e) => {
              touchStartX = e.touches[0].clientX;
              touchStartY = e.touches[0].clientY;
              isHorizontalSwipe = false;
            },
            { passive: true },
          );
          content.addEventListener(
            'touchmove',
            (e) => {
              e.preventDefault();
              const dx = Math.abs(e.touches[0].clientX - touchStartX);
              const dy = Math.abs(e.touches[0].clientY - touchStartY);
              if (!isHorizontalSwipe && dx > dy && dx > 10) {
                isHorizontalSwipe = true;
              }
            },
            { passive: false },
          );
          content.addEventListener(
            'touchend',
            (e) => {
              const dx = touchStartX - e.changedTouches[0].clientX;
              const dy = touchStartY - e.changedTouches[0].clientY;
              if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
                this.navigate(dx > 0 ? 1 : -1);
              }
            },
            { passive: true },
          );
        }
      }

      navigate(direction) {
        const items = Array.from(this.querySelectorAll('[data-media-id]'));
        const currentIndex = items.findIndex((el) => el.classList.contains('active'));
        const nextIndex = (currentIndex + direction + items.length) % items.length;

        items.forEach((el) => el.classList.remove('active'));
        items[nextIndex].classList.add('active');

        const content = this.querySelector('[role="document"]');
        if (content) content.scrollTop = 0;
      }
    },
  );
}
